const ParametroTipoEnum = {
  String: 1,
  Inteiro: 2,
  Float: 3,
  Decimal: 4,
  Long: 5,
  Boolean: 6,
  Date: 7,
  File: 8
};

export default ParametroTipoEnum;
